import { eLockInfo } from 'sections/PromoSection/modules/ELockModule/components/Description/types'
import { ConferenceDataType } from 'sections/PromoSection/pages/ConferencesPage/types'
import { SortingCenterType } from 'sections/PromoSection/pages/ListPages/ListSignBoardsSortingCentersPage/types'

export type LinkType = {
  href: string
  hrefText: string
  linkType?: 'hash' | 'search' | 'pathname'
  path?: string
  download?: boolean
  target?: '_blank' | '_self'
  img?: string
}

export type InputRangeData = {
  title: string
  minValue: number
  maxValue: number
  stepValue: number
  defaultValue: number
}

export type ErrorResponseData = {
  error: {
    code: string
    data?: { key: string; value: string }[]
    message?: string
  }
}

export type PropType<TObj, TProp extends keyof TObj> = TObj[TProp]

export type FaqData = {
  index: number
  answer: string
  question: string
} & Partial<LinkType>

export type ConferenceData = {
  conferenceData: ConferenceDataType
  description: string
}

export type SortingCentersData = {
  sortingCentersData: SortingCenterType[]
}

export enum SectionName {
  faq = 'Faq',
  contractors = 'Contractors',
  conferences = 'Conferences',
  sortingCenters = 'SortingCenters',
  elock = 'ELock',
}

export type ElockData = {
  elockTableData: eLockInfo[]
  elockHowToInstallData: ElockHowToInstallData[]
}

export type ElockHowToInstallData = {
  installationInstructions: string
  controllerDescription: string
  index: number
}

export type ContractorDataItemType = {
  index: number
  img: string
  title: string
  description: string
  link: string
  additionalLink: string
  email: string
  downloadLink: string
  phone: string
}

export type VideoMonitoringContractorDataItem = {
  index: number
  title: string
  websiteLink: string
  instructionsLink: string
}

export type VideoMonitoringCountryData = {
  index: number
  country: string
  contractors: VideoMonitoringContractorDataItem[]
}

export type ContractorData = {
  videoConnectionData: VideoMonitoringCountryData[]
  signboardData: ContractorDataItemType[]
  outsourcingData: ContractorDataItemType[]
  description: string
}

export type SectionContent = {
  title: string
  visible: boolean
  data: SectionData
}

export type SectionData = FaqData[] | ContractorData | ConferenceData | SortingCentersData | ElockData

export type SectionDTO = {
  content: SectionData
  index: number
  title: string
  type: SectionName
}

export type SectionsDTO = {
  sections: SectionDTO[]
}

export interface WbaEventParams {
  [key: string]: string | number | boolean
}

interface WbaFunction {
  (eventName: string, params?: WbaEventParams): void
}

declare global {
  interface Window {
    wba: WbaFunction
    wbaQueue: Array<[string, WbaEventParams]>
    _wba?: WbaFunction
    ReactNativeWebView: {
      postMessage: (message: string) => void
    }
  }
}

export const enum EventType {
  HeaderT = 'Header_T',
  MainFormPUPT = 'Main_Form_PUP_T',
  MainCartPUPT = 'Main_Cart_PUP_T',
  MainFormPUPSend = 'Main_Form_PUP_Send',
  MainFindRoomT = 'Main_Find_Room_T',
  MainSendRequestT = 'Main_Send_Request_T',
  createOrder = 'Create_Application_T',
  orderStep = 'Create_Application_Response',
  registration = 'Register_Step_Response',
  PVZOpen = 'PVZ_Open_T',
  BannerS = 'Banner_S',
  BannerT = 'Banner_T',
  ConditionsDetailsT = 'Conditions_Details_T',
  BrandbookDnl = 'Brandbook_Dnl',
  ChecklistDnl = 'Checklist_Dnl',
  FAQElementT = 'FAQ_Element_T',
  FooterT = 'Footer_T',
  StoriesT = 'Stories_T',
}

export const enum AdriverEventType {
  allQuestions = 'Vse_voprosy_i_otvety',
  openMap = 'Otkryt_kartu',
  openMapSimplifiedPage = 'Otkryt_kartu_uproshennye',
  showVariants = 'Posmotret_varianty',
  downloadChecklist = 'Skachat_chek-list_po_otkrytiyu_PVZ',
  socialIcons = 'Ssylki_na_soc_seti',
  findOutMore = 'Uznat_podrobnee',
  openPVZ = 'Otkryt_PVZ',
  openPVZHeader = 'Otkryt_PVZ_header',
  openPVZSimplifiedPage = 'Otkryt_PVZ_uproshennye',
}

export interface PromoSiteContactRequest {
  phoneNumber: string
  email: string
  telegram: string
  message: string
}
